import React from "react";
import style from "../caterpilar-plague/total-informations/total-informations.module.css";

function colorForLevelKey(levelKey) {
  if (levelKey === "none") return "#595959";
  if (levelKey === "muitoBaixo" || levelKey === "muitoBaixa") return "#1e5c16";
  if (levelKey === "baixo" || levelKey === "baixa") return "#358128";
  if (levelKey === "medio" || levelKey === "media") return "#FEC601";
  return "#ff0000";
}

/**
 * Painel de nível (texto de resultado + faixa colorida).
 * @param {{ label: string, value: string|number }[]} lines
 * @param {string} displayText — texto na faixa (pode ser "-" para caso epsilon)
 * @param {string} levelKey — chave para cor de fundo
 */
function BracellLevelPanel({ lines = [], displayText, levelKey }) {
  const bg = colorForLevelKey(levelKey || "none");
  return (
    <>
      <div className={style.card}>
        <div className={style["title-card"]}>Resultados</div>
        <div className={style["group-informations"]}>
          {lines.map((line, i) => (
            <div key={i} className={style["total-percentual"]}>
              <div>{line.label}</div>
              <p>{line.value}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={style.card}>
        <div className={style["title-card"]}>Nível de infestação</div>
        <div className={style["level-infestation"]}>
          <div className={style.status} style={{ backgroundColor: bg }}>
            {displayText}
          </div>
        </div>
      </div>
    </>
  );
}

export default BracellLevelPanel;
